import React from 'react'

const Error = ()=>{
    return(
        <div>
            <p style={{margin:'50px',fontSize:'20px'}}>Нашиот сервер моментално е преоптоварен, ве молиме обидете се повторно подоцна</p>
            <p style={{margin:'50px',fontSize:'20px'}}>Our server is currently overloaded. Please try again later!</p>
        </div>
    )
}

export default Error;